module.exports = function(dispatcher) {
  return function(email) {
    dispatcher.dispatch({
      type: 'saveEmail',
      email
    });
  };
};
